import { UploadRecord } from "../types"

// Mirrors study-plan's createStudent: trim, and omit the field when empty.
export const getExternalStudentId = (
  record: UploadRecord
): string | undefined => record.externalStudentId?.trim() || undefined
